import AHDate from "_shared/dates/date";

/**
 * How long ago, at a glance rather than to the minute.
 *
 * Recent notifications are read by their distance from now — "what moved while I was out" — and a
 * row that says "2d ago" answers that in fewer characters than a date does. Past a week the
 * distance stops meaning anything ("14d ago" is not a thing anyone counts), so the label becomes
 * the date itself.
 *
 * Callers that render a list of these should compute `now` once for the whole render and pass the
 * same value to every row, so the rows cannot disagree about when "now" was.
 */
export default function relativeTimeLabel(createdDate: AHDate, now: Date): string {
  const elapsedMinutes = Math.floor((now.getTime() - createdDate.asMoment.toDate().getTime()) / 60000);
  if (elapsedMinutes < 1) return "Just now";
  if (elapsedMinutes < 60) return `${elapsedMinutes}m ago`;
  const elapsedHours = Math.floor(elapsedMinutes / 60);
  if (elapsedHours < 24) return `${elapsedHours}h ago`;
  const elapsedDays = Math.floor(elapsedHours / 24);
  if (elapsedDays < 7) return `${elapsedDays}d ago`;
  return createdDate.format("MMM D");
}
